import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function ArrowRoundedOut(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 25 20">
        <path d="M17.02655 2.9382c.31123.31706.31123.83111 0 1.14817-.31123.31705-.81584.31705-1.12707 0C12.68306.80976 7.47694.80219 4.27128 4.06783c-3.20565 3.26564-3.19823 8.56919.0182 11.8458 3.21642 3.27661 8.42254 3.28418 11.6282.01854.31123-.31706.81584-.31706 1.12707 0 .31123.31705.31123.8311 0 1.14816-3.82884 3.90049-10.04417 3.89145-13.88234-.01854C-.67576 13.1518-.68463 6.82016 3.1442 2.91967c3.82884-3.90049 10.04417-3.89145 13.88234.01854zm4.47701 10.85108c-.28135.28096-.73613.28096-1.01748 0-.28136-.28095-.28136-.73507 0-1.01603l2.0616-2.05865h-6.8281c-.39793 0-.71958-.32191-.71958-.71855 0-.39736.32165-.71855.71958-.71855h6.81946l-2.05296-2.05075c-.14032-.14012-.21084-.32407-.21084-.50802s.07052-.3679.21084-.50801c.28063-.28096.73613-.28096 1.01748 0l3.2856 3.28162c.13528.13437.21084.31688.21084.50802a.71738.71738 0 0 1-.21084.50802l-3.2856 3.2809z" />
      </svg>
    </IconContainer>
  )
}
